/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises5Inputs */

const en__field_enum_berufliches_gymnasium_des_main_kinzig_kreises5 = /** @type {(inputs: _Field_Enum_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gelnhausen`)
};

const de__field_enum_berufliches_gymnasium_des_main_kinzig_kreises5 = /** @type {(inputs: _Field_Enum_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berufliches Gymnasium des Main-Kinzig-Kreises`)
};

/**
* | output |
* | --- |
* | "Gelnhausen" |
*
* @param {_Field_Enum_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_berufliches_gymnasium_des_main_kinzig_kreises5 = /** @type {((inputs?: _Field_Enum_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Berufliches_Gymnasium_Des_Main_Kinzig_Kreises5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_berufliches_gymnasium_des_main_kinzig_kreises5(inputs)
	return de__field_enum_berufliches_gymnasium_des_main_kinzig_kreises5(inputs)
});
export { _field_enum_berufliches_gymnasium_des_main_kinzig_kreises5 as "_field_enum_Berufliches_Gymnasium_des_Main_Kinzig_Kreises" }